@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_722_968_247)
public val Res.string.roster_import_layout_hint: StringResource by lazy {
      StringResource("string:roster_import_layout_hint", "roster_import_layout_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255024, 161),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 361768, 253),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233415, 157),
      ))
    }

@delegate:ResourceContentHash(1_555_772_120)
public val Res.string.roster_import_layout_next: StringResource by lazy {
      StringResource("string:roster_import_layout_next", "roster_import_layout_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255186, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362022, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233573, 53),
      ))
    }

@delegate:ResourceContentHash(2_072_563_550)
public val Res.string.roster_import_layout_title: StringResource by lazy {
      StringResource("string:roster_import_layout_title", "roster_import_layout_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255240, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362092, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233627, 70),
      ))
    }

@delegate:ResourceContentHash(1_891_199_360)
public val Res.string.roster_import_legend_problem: StringResource by lazy {
      StringResource("string:roster_import_legend_problem", "roster_import_legend_problem", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255311, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362171, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233698, 56),
      ))
    }

@delegate:ResourceContentHash(530_515_856)
public val Res.string.roster_import_legend_skipped: StringResource by lazy {
      StringResource("string:roster_import_legend_skipped", "roster_import_legend_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255392, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362272, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233755, 48),
      ))
    }

@delegate:ResourceContentHash(-1_401_280_496)
public val Res.string.roster_import_legend_without_person: StringResource by lazy {
      StringResource("string:roster_import_legend_without_person", "roster_import_legend_without_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255445, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362333, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233804, 79),
      ))
    }

@delegate:ResourceContentHash(752_745_115)
public val Res.string.roster_import_match_ambiguous: StringResource by lazy {
      StringResource("string:roster_import_match_ambiguous", "roster_import_match_ambiguous", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255517, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362437, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233884, 77),
      ))
    }

@delegate:ResourceContentHash(867_294_182)
public val Res.string.roster_import_match_exact: StringResource by lazy {
      StringResource("string:roster_import_match_exact", "roster_import_match_exact", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255603, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362563, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233962, 45),
      ))
    }

@delegate:ResourceContentHash(-141_910_709)
public val Res.string.roster_import_match_likely: StringResource by lazy {
      StringResource("string:roster_import_match_likely", "roster_import_match_likely", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255653, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362633, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234008, 74),
      ))
    }

@delegate:ResourceContentHash(420_333_677)
public val Res.string.roster_import_match_none: StringResource by lazy {
      StringResource("string:roster_import_match_none", "roster_import_match_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255732, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362744, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234083, 76),
      ))
    }

@delegate:ResourceContentHash(215_429_546)
public val Res.string.roster_import_names_and_days_same_column: StringResource by lazy {
      StringResource("string:roster_import_names_and_days_same_column", "roster_import_names_and_days_same_column", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255817, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 362865, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234160, 120),
      ))
    }

@delegate:ResourceContentHash(-355_850_732)
public val Res.string.roster_import_names_set: StringResource by lazy {
      StringResource("string:roster_import_names_set", "roster_import_names_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255934, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 363022, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234281, 59),
      ))
    }

@delegate:ResourceContentHash(-1_213_246_780)
public val Res.string.roster_import_names_unset: StringResource by lazy {
      StringResource("string:roster_import_names_unset", "roster_import_names_unset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 255998, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 363098, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234341, 89),
      ))
    }

@delegate:ResourceContentHash(-155_080_148)
public val Res.string.roster_import_new_people_hint: StringResource by lazy {
      StringResource("string:roster_import_new_people_hint", "roster_import_new_people_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 256100, 177),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 363244, 269),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234431, 157),
      ))
    }

@delegate:ResourceContentHash(2_083_575_841)
public val Res.string.roster_import_nothing_found: StringResource by lazy {
      StringResource("string:roster_import_nothing_found", "roster_import_nothing_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 256278, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 363514, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234589, 171),
      ))
    }

@delegate:ResourceContentHash(-1_214_722_237)
public val Res.string.roster_import_paste_hint: StringResource by lazy {
      StringResource("string:roster_import_paste_hint", "roster_import_paste_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 256446, 176),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 363750, 264),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234761, 196),
      ))
    }

@delegate:ResourceContentHash(-1_458_184_792)
public val Res.string.roster_import_paste_title: StringResource by lazy {
      StringResource("string:roster_import_paste_title", "roster_import_paste_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 256623, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 364015, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234958, 93),
      ))
    }

@delegate:ResourceContentHash(1_867_107_432)
public val Res.string.roster_import_people_hint: StringResource by lazy {
      StringResource("string:roster_import_people_hint", "roster_import_people_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 256713, 309),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 364133, 461),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235052, 265),
      ))
    }

@delegate:ResourceContentHash(2_102_508_974)
public val Res.string.roster_import_people_next: StringResource by lazy {
      StringResource("string:roster_import_people_next", "roster_import_people_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257023, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 364595, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235318, 61),
      ))
    }

@delegate:ResourceContentHash(-662_207_175)
public val Res.string.roster_import_people_stay: StringResource by lazy {
      StringResource("string:roster_import_people_stay", "roster_import_people_stay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257089, 193),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 364681, 293),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235380, 149),
      ))
    }

@delegate:ResourceContentHash(-14_610_567)
public val Res.string.roster_import_people_title: StringResource by lazy {
      StringResource("string:roster_import_people_title", "roster_import_people_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257283, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 364975, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235530, 50),
      ))
    }

@delegate:ResourceContentHash(-612_206_512)
public val Res.string.roster_import_people_undecided: StringResource by lazy {
      StringResource("string:roster_import_people_undecided", "roster_import_people_undecided", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257338, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365034, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235581, 86),
      ))
    }

@delegate:ResourceContentHash(-56_032_561)
public val Res.string.roster_import_person_is: StringResource by lazy {
      StringResource("string:roster_import_person_is", "roster_import_person_is", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257441, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365173, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235668, 59),
      ))
    }

@delegate:ResourceContentHash(-1_547_920_328)
public val Res.string.roster_import_planned_add: StringResource by lazy {
      StringResource("string:roster_import_planned_add", "roster_import_planned_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257489, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365237, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235728, 97),
      ))
    }

@delegate:ResourceContentHash(446_793_388)
public val Res.string.roster_import_planned_replace: StringResource by lazy {
      StringResource("string:roster_import_planned_replace", "roster_import_planned_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257587, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365391, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235826, 93),
      ))
    }

@delegate:ResourceContentHash(-609_474_758)
public val Res.string.roster_import_planned_skip: StringResource by lazy {
      StringResource("string:roster_import_planned_skip", "roster_import_planned_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257685, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365549, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235920, 82),
      ))
    }

@delegate:ResourceContentHash(-837_536_151)
public val Res.string.roster_import_planned_title: StringResource by lazy {
      StringResource("string:roster_import_planned_title", "roster_import_planned_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257764, 147),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365672, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236003, 163),
      ))
    }

@delegate:ResourceContentHash(48_169_981)
public val Res.string.roster_import_preview_hint: StringResource by lazy {
      StringResource("string:roster_import_preview_hint", "roster_import_preview_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 257912, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 365876, 250),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236167, 122),
      ))
    }

@delegate:ResourceContentHash(-1_123_897_460)
public val Res.string.roster_import_preview_title: StringResource by lazy {
      StringResource("string:roster_import_preview_title", "roster_import_preview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258071, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366127, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236290, 55),
      ))
    }

@delegate:ResourceContentHash(-1_039_218_743)
public val Res.string.roster_import_problem_missing_template: StringResource by lazy {
      StringResource("string:roster_import_problem_missing_template", "roster_import_problem_missing_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258131, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366199, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236346, 158),
      ))
    }

@delegate:ResourceContentHash(1_129_247_334)
public val Res.string.roster_import_problem_overlapping: StringResource by lazy {
      StringResource("string:roster_import_problem_overlapping", "roster_import_problem_overlapping", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258278, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366398, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236505, 85),
      ))
    }

@delegate:ResourceContentHash(-1_838_341_196)
public val Res.string.roster_import_problem_unknown_code: StringResource by lazy {
      StringResource("string:roster_import_problem_unknown_code", "roster_import_problem_unknown_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258388, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366524, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236591, 154),
      ))
    }

@delegate:ResourceContentHash(-1_292_749_050)
public val Res.string.roster_import_read_only: StringResource by lazy {
      StringResource("string:roster_import_read_only", "roster_import_read_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258543, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366723, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236746, 179),
      ))
    }

@delegate:ResourceContentHash(-1_309_529_636)
public val Res.string.roster_import_replaced: StringResource by lazy {
      StringResource("string:roster_import_replaced", "roster_import_replaced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258735, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 366967, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236926, 78),
      ))
    }

@delegate:ResourceContentHash(1_607_795_413)
public val Res.string.roster_import_sheet_cut: StringResource by lazy {
      StringResource("string:roster_import_sheet_cut", "roster_import_sheet_cut", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258826, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367102, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237005, 143),
      ))
    }

@delegate:ResourceContentHash(-1_349_106_240)
public val Res.string.roster_import_shift_end: StringResource by lazy {
      StringResource("string:roster_import_shift_end", "roster_import_shift_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 258970, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367306, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237149, 35),
      ))
    }

@delegate:ResourceContentHash(-1_289_022_070)
public val Res.string.roster_import_shift_start: StringResource by lazy {
      StringResource("string:roster_import_shift_start", "roster_import_shift_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259010, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367354, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237185, 41),
      ))
    }

@delegate:ResourceContentHash(996_583_450)
public val Res.string.roster_import_skip_all: StringResource by lazy {
      StringResource("string:roster_import_skip_all", "roster_import_skip_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259056, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367408, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237227, 70),
      ))
    }

@delegate:ResourceContentHash(918_527_093)
public val Res.string.roster_import_skip_cell: StringResource by lazy {
      StringResource("string:roster_import_skip_cell", "roster_import_skip_cell", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259139, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367531, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237298, 51),
      ))
    }

@delegate:ResourceContentHash(-514_265_892)
public val Res.string.roster_import_target_first_day: StringResource by lazy {
      StringResource("string:roster_import_target_first_day", "roster_import_target_first_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259199, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367619, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237350, 66),
      ))
    }

@delegate:ResourceContentHash(-1_527_616_542)
public val Res.string.roster_import_target_header: StringResource by lazy {
      StringResource("string:roster_import_target_header", "roster_import_target_header", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259270, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367710, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237417, 87),
      ))
    }

@delegate:ResourceContentHash(206_300_942)
public val Res.string.roster_import_target_names: StringResource by lazy {
      StringResource("string:roster_import_target_names", "roster_import_target_names", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259354, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367818, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237505, 62),
      ))
    }

@delegate:ResourceContentHash(1_740_314_494)
public val Res.string.roster_import_template_label: StringResource by lazy {
      StringResource("string:roster_import_template_label", "roster_import_template_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259417, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367901, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237568, 48),
      ))
    }

@delegate:ResourceContentHash(-768_093_682)
public val Res.string.roster_import_times_invalid: StringResource by lazy {
      StringResource("string:roster_import_times_invalid", "roster_import_times_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259466, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 367954, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237617, 71),
      ))
    }

@delegate:ResourceContentHash(-619_712_915)
public val Res.string.roster_import_title: StringResource by lazy {
      StringResource("string:roster_import_title", "roster_import_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259546, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368046, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237689, 75),
      ))
    }

@delegate:ResourceContentHash(1_857_398_831)
public val Res.string.roster_import_undo: StringResource by lazy {
      StringResource("string:roster_import_undo", "roster_import_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259844, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368456, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238003, 46),
      ))
    }

@delegate:ResourceContentHash(-809_296_674)
public val Res.string.roster_import_undone: StringResource by lazy {
      StringResource("string:roster_import_undone", "roster_import_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259779, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368383, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237942, 60),
      ))
    }

@delegate:ResourceContentHash(-1_610_293_183)
public val Res.string.roster_import_undone_hint: StringResource by lazy {
      StringResource("string:roster_import_undone_hint", "roster_import_undone_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259610, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368146, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237765, 121),
      ))
    }

@delegate:ResourceContentHash(-1_537_052_919)
public val Res.string.roster_import_undone_title: StringResource by lazy {
      StringResource("string:roster_import_undone_title", "roster_import_undone_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259720, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368304, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237887, 54),
      ))
    }

@delegate:ResourceContentHash(1_993_640_107)
public val Res.string.roster_import_unsupported: StringResource by lazy {
      StringResource("string:roster_import_unsupported", "roster_import_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 259891, 497),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 368527, 733),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238050, 413),
      ))
    }

@delegate:ResourceContentHash(1_364_116_673)
public val Res.string.roster_import_without_person_absent: StringResource by lazy {
      StringResource("string:roster_import_without_person_absent", "roster_import_without_person_absent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 260389, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 369261, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238464, 159),
      ))
    }

@delegate:ResourceContentHash(362_148_525)
public val Res.string.roster_import_without_person_double_booked: StringResource by lazy {
      StringResource("string:roster_import_without_person_double_booked", "roster_import_without_person_double_booked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 260545, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 369485, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238624, 154),
      ))
    }

@delegate:ResourceContentHash(821_871_239)
public val Res.string.roster_import_without_person_inactive: StringResource by lazy {
      StringResource("string:roster_import_without_person_inactive", "roster_import_without_person_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 260692, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 369688, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238779, 153),
      ))
    }

@delegate:ResourceContentHash(-186_321_289)
public val Res.string.roster_import_without_person_unavailable: StringResource by lazy {
      StringResource("string:roster_import_without_person_unavailable", "roster_import_without_person_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 260834, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 369902, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238933, 152),
      ))
    }

@delegate:ResourceContentHash(-2_101_977_327)
public val Res.string.roster_labour_code: StringResource by lazy {
      StringResource("string:roster_labour_code", "roster_labour_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261572, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371124, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239619, 42),
      ))
    }

@delegate:ResourceContentHash(1_387_407_055)
public val Res.string.roster_labour_code_hint: StringResource by lazy {
      StringResource("string:roster_labour_code_hint", "roster_labour_code_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 260995, 403),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 370139, 719),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239086, 391),
      ))
    }

@delegate:ResourceContentHash(1_304_707_101)
public val Res.string.roster_labour_code_none: StringResource by lazy {
      StringResource("string:roster_labour_code_none", "roster_labour_code_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261399, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 370859, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239478, 79),
      ))
    }

@delegate:ResourceContentHash(-823_789_603)
public val Res.string.roster_labour_code_title: StringResource by lazy {
      StringResource("string:roster_labour_code_title", "roster_labour_code_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261499, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371015, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239558, 60),
      ))
    }

@delegate:ResourceContentHash(-1_395_237_630)
public val Res.string.roster_more_actions: StringResource by lazy {
      StringResource("string:roster_more_actions", "roster_more_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261615, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371183, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239662, 43),
      ))
    }

@delegate:ResourceContentHash(-1_502_861_416)
public val Res.string.roster_move_started: StringResource by lazy {
      StringResource("string:roster_move_started", "roster_move_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261663, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371239, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239706, 91),
      ))
    }

@delegate:ResourceContentHash(1_269_942_252)
public val Res.string.roster_next_month: StringResource by lazy {
      StringResource("string:roster_next_month", "roster_next_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261779, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371387, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239798, 41),
      ))
    }

@delegate:ResourceContentHash(-1_782_854_812)
public val Res.string.roster_no_day_templates: StringResource by lazy {
      StringResource("string:roster_no_day_templates", "roster_no_day_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261829, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371457, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239840, 99),
      ))
    }

@delegate:ResourceContentHash(454_263_615)
public val Res.string.roster_no_employee: StringResource by lazy {
      StringResource("string:roster_no_employee", "roster_no_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261921, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371597, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239940, 54),
      ))
    }

@delegate:ResourceContentHash(887_093_782)
public val Res.string.roster_no_open_skeleton_shifts: StringResource by lazy {
      StringResource("string:roster_no_open_skeleton_shifts", "roster_no_open_skeleton_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 261988, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371688, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239995, 90),
      ))
    }

@delegate:ResourceContentHash(-1_397_386_379)
public val Res.string.roster_no_templates: StringResource by lazy {
      StringResource("string:roster_no_templates", "roster_no_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262079, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371839, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240086, 87),
      ))
    }

@delegate:ResourceContentHash(754_482_509)
public val Res.string.roster_open_shift_claimed: StringResource by lazy {
      StringResource("string:roster_open_shift_claimed", "roster_open_shift_claimed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262171, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 371967, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240174, 65),
      ))
    }

@delegate:ResourceContentHash(-1_840_018_621)
public val Res.string.roster_open_shift_hint: StringResource by lazy {
      StringResource("string:roster_open_shift_hint", "roster_open_shift_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262237, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372037, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240240, 110),
      ))
    }

@delegate:ResourceContentHash(1_196_123_827)
public val Res.string.roster_open_shift_label: StringResource by lazy {
      StringResource("string:roster_open_shift_label", "roster_open_shift_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262348, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372208, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240351, 67),
      ))
    }

@delegate:ResourceContentHash(753_024_042)
public val Res.string.roster_open_shift_toggle: StringResource by lazy {
      StringResource("string:roster_open_shift_toggle", "roster_open_shift_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262420, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372308, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240419, 48),
      ))
    }

@delegate:ResourceContentHash(-180_144_348)
public val Res.string.roster_open_short: StringResource by lazy {
      StringResource("string:roster_open_short", "roster_open_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262469, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372373, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240468, 37),
      ))
    }

@delegate:ResourceContentHash(-2_059_237_152)
public val Res.string.roster_overview_availability: StringResource by lazy {
      StringResource("string:roster_overview_availability", "roster_overview_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262511, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372423, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240506, 80),
      ))
    }

@delegate:ResourceContentHash(2_019_992_080)
public val Res.string.roster_overview_by_email: StringResource by lazy {
      StringResource("string:roster_overview_by_email", "roster_overview_by_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262604, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372536, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240587, 44),
      ))
    }

@delegate:ResourceContentHash(-3_117_877)
public val Res.string.roster_overview_no_warnings: StringResource by lazy {
      StringResource("string:roster_overview_no_warnings", "roster_overview_no_warnings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262653, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372617, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240632, 79),
      ))
    }

@delegate:ResourceContentHash(-1_770_497_353)
public val Res.string.roster_overview_team: StringResource by lazy {
      StringResource("string:roster_overview_team", "roster_overview_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262753, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372761, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240712, 52),
      ))
    }

@delegate:ResourceContentHash(-1_719_521_208)
public val Res.string.roster_overview_title: StringResource by lazy {
      StringResource("string:roster_overview_title", "roster_overview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262806, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372826, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240765, 45),
      ))
    }

@delegate:ResourceContentHash(-112_393_525)
public val Res.string.roster_overview_warnings: StringResource by lazy {
      StringResource("string:roster_overview_warnings", "roster_overview_warnings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262852, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372884, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240811, 52),
      ))
    }

@delegate:ResourceContentHash(1_855_313_932)
public val Res.string.roster_picker_absent: StringResource by lazy {
      StringResource("string:roster_picker_absent", "roster_picker_absent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262909, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 372961, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240864, 44),
      ))
    }

@delegate:ResourceContentHash(125_343_440)
public val Res.string.roster_picker_away: StringResource by lazy {
      StringResource("string:roster_picker_away", "roster_picker_away", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 262966, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373030, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240909, 46),
      ))
    }

@delegate:ResourceContentHash(980_466_044)
public val Res.string.roster_picker_guest_from: StringResource by lazy {
      StringResource("string:roster_picker_guest_from", "roster_picker_guest_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263025, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373113, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240956, 44),
      ))
    }

@delegate:ResourceContentHash(-2_125_154_068)
public val Res.string.roster_picker_guests_hint: StringResource by lazy {
      StringResource("string:roster_picker_guests_hint", "roster_picker_guests_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263078, 153),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373182, 245),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241001, 157),
      ))
    }

@delegate:ResourceContentHash(-1_907_010_106)
public val Res.string.roster_picker_month_hours: StringResource by lazy {
      StringResource("string:roster_picker_month_hours", "roster_picker_month_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263313, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373529, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241236, 57),
      ))
    }

@delegate:ResourceContentHash(1_294_615_572)
public val Res.string.roster_picker_month_hours_target: StringResource by lazy {
      StringResource("string:roster_picker_month_hours_target", "roster_picker_month_hours_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263232, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373428, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241159, 76),
      ))
    }

@delegate:ResourceContentHash(844_968_946)
public val Res.string.roster_picker_nobody: StringResource by lazy {
      StringResource("string:roster_picker_nobody", "roster_picker_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263379, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373611, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241294, 116),
      ))
    }

@delegate:ResourceContentHash(1_563_380_045)
public val Res.string.roster_picker_over_target: StringResource by lazy {
      StringResource("string:roster_picker_over_target", "roster_picker_over_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263512, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373804, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241411, 89),
      ))
    }

@delegate:ResourceContentHash(1_853_736_825)
public val Res.string.roster_picker_same_day: StringResource by lazy {
      StringResource("string:roster_picker_same_day", "roster_picker_same_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263598, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 373930, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241501, 62),
      ))
    }

@delegate:ResourceContentHash(-279_677_570)
public val Res.string.roster_picker_title: StringResource by lazy {
      StringResource("string:roster_picker_title", "roster_picker_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263657, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374001, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241564, 55),
      ))
    }

@delegate:ResourceContentHash(1_043_955_763)
public val Res.string.roster_planned_hours: StringResource by lazy {
      StringResource("string:roster_planned_hours", "roster_planned_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263777, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374157, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241680, 48),
      ))
    }

@delegate:ResourceContentHash(-428_613_214)
public val Res.string.roster_planned_hours_of: StringResource by lazy {
      StringResource("string:roster_planned_hours_of", "roster_planned_hours_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263717, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374077, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241620, 59),
      ))
    }

@delegate:ResourceContentHash(1_446_456_461)
public val Res.string.roster_planned_time: StringResource by lazy {
      StringResource("string:roster_planned_time", "roster_planned_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263830, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374226, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241729, 43),
      ))
    }

@delegate:ResourceContentHash(-373_705_876)
public val Res.string.roster_previous_month: StringResource by lazy {
      StringResource("string:roster_previous_month", "roster_previous_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263878, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374298, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241773, 49),
      ))
    }

@delegate:ResourceContentHash(-423_918_841)
public val Res.string.roster_publish: StringResource by lazy {
      StringResource("string:roster_publish", "roster_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264593, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375365, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242484, 34),
      ))
    }

@delegate:ResourceContentHash(-629_041_699)
public val Res.string.roster_publish_changes: StringResource by lazy {
      StringResource("string:roster_publish_changes", "roster_publish_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263932, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374372, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241823, 50),
      ))
    }

@delegate:ResourceContentHash(-847_058_130)
public val Res.string.roster_publish_keep_open: StringResource by lazy {
      StringResource("string:roster_publish_keep_open", "roster_publish_keep_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 263987, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374451, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241874, 64),
      ))
    }

@delegate:ResourceContentHash(-1_898_478_434)
public val Res.string.roster_publish_leftovers: StringResource by lazy {
      StringResource("string:roster_publish_leftovers", "roster_publish_leftovers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264048, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374536, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241939, 124),
      ))
    }

@delegate:ResourceContentHash(-350_922_180)
public val Res.string.roster_publish_open_note: StringResource by lazy {
      StringResource("string:roster_publish_open_note", "roster_publish_open_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264177, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374765, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242064, 84),
      ))
    }

@delegate:ResourceContentHash(1_388_536_433)
public val Res.string.roster_publish_remove: StringResource by lazy {
      StringResource("string:roster_publish_remove", "roster_publish_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264254, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374870, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242149, 61),
      ))
    }

@delegate:ResourceContentHash(1_782_782_921)
public val Res.string.roster_published: StringResource by lazy {
      StringResource("string:roster_published", "roster_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264359, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375023, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242254, 48),
      ))
    }

@delegate:ResourceContentHash(-1_506_920_515)
public val Res.string.roster_published_state: StringResource by lazy {
      StringResource("string:roster_published_state", "roster_published_state", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264312, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 374960, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242211, 42),
      ))
    }

@delegate:ResourceContentHash(-754_273_346)
public val Res.string.roster_publishing: StringResource by lazy {
      StringResource("string:roster_publishing", "roster_publishing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264535, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375291, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242426, 57),
      ))
    }

@delegate:ResourceContentHash(710_136_087)
public val Res.string.roster_publishing_hint: StringResource by lazy {
      StringResource("string:roster_publishing_hint", "roster_publishing_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264412, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375100, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242303, 122),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString32Resources(map: MutableMap<String, StringResource>) {
  map.put("roster_import_layout_hint", Res.string.roster_import_layout_hint)
  map.put("roster_import_layout_next", Res.string.roster_import_layout_next)
  map.put("roster_import_layout_title", Res.string.roster_import_layout_title)
  map.put("roster_import_legend_problem", Res.string.roster_import_legend_problem)
  map.put("roster_import_legend_skipped", Res.string.roster_import_legend_skipped)
  map.put("roster_import_legend_without_person", Res.string.roster_import_legend_without_person)
  map.put("roster_import_match_ambiguous", Res.string.roster_import_match_ambiguous)
  map.put("roster_import_match_exact", Res.string.roster_import_match_exact)
  map.put("roster_import_match_likely", Res.string.roster_import_match_likely)
  map.put("roster_import_match_none", Res.string.roster_import_match_none)
  map.put("roster_import_names_and_days_same_column", Res.string.roster_import_names_and_days_same_column)
  map.put("roster_import_names_set", Res.string.roster_import_names_set)
  map.put("roster_import_names_unset", Res.string.roster_import_names_unset)
  map.put("roster_import_new_people_hint", Res.string.roster_import_new_people_hint)
  map.put("roster_import_nothing_found", Res.string.roster_import_nothing_found)
  map.put("roster_import_paste_hint", Res.string.roster_import_paste_hint)
  map.put("roster_import_paste_title", Res.string.roster_import_paste_title)
  map.put("roster_import_people_hint", Res.string.roster_import_people_hint)
  map.put("roster_import_people_next", Res.string.roster_import_people_next)
  map.put("roster_import_people_stay", Res.string.roster_import_people_stay)
  map.put("roster_import_people_title", Res.string.roster_import_people_title)
  map.put("roster_import_people_undecided", Res.string.roster_import_people_undecided)
  map.put("roster_import_person_is", Res.string.roster_import_person_is)
  map.put("roster_import_planned_add", Res.string.roster_import_planned_add)
  map.put("roster_import_planned_replace", Res.string.roster_import_planned_replace)
  map.put("roster_import_planned_skip", Res.string.roster_import_planned_skip)
  map.put("roster_import_planned_title", Res.string.roster_import_planned_title)
  map.put("roster_import_preview_hint", Res.string.roster_import_preview_hint)
  map.put("roster_import_preview_title", Res.string.roster_import_preview_title)
  map.put("roster_import_problem_missing_template", Res.string.roster_import_problem_missing_template)
  map.put("roster_import_problem_overlapping", Res.string.roster_import_problem_overlapping)
  map.put("roster_import_problem_unknown_code", Res.string.roster_import_problem_unknown_code)
  map.put("roster_import_read_only", Res.string.roster_import_read_only)
  map.put("roster_import_replaced", Res.string.roster_import_replaced)
  map.put("roster_import_sheet_cut", Res.string.roster_import_sheet_cut)
  map.put("roster_import_shift_end", Res.string.roster_import_shift_end)
  map.put("roster_import_shift_start", Res.string.roster_import_shift_start)
  map.put("roster_import_skip_all", Res.string.roster_import_skip_all)
  map.put("roster_import_skip_cell", Res.string.roster_import_skip_cell)
  map.put("roster_import_target_first_day", Res.string.roster_import_target_first_day)
  map.put("roster_import_target_header", Res.string.roster_import_target_header)
  map.put("roster_import_target_names", Res.string.roster_import_target_names)
  map.put("roster_import_template_label", Res.string.roster_import_template_label)
  map.put("roster_import_times_invalid", Res.string.roster_import_times_invalid)
  map.put("roster_import_title", Res.string.roster_import_title)
  map.put("roster_import_undo", Res.string.roster_import_undo)
  map.put("roster_import_undone", Res.string.roster_import_undone)
  map.put("roster_import_undone_hint", Res.string.roster_import_undone_hint)
  map.put("roster_import_undone_title", Res.string.roster_import_undone_title)
  map.put("roster_import_unsupported", Res.string.roster_import_unsupported)
  map.put("roster_import_without_person_absent", Res.string.roster_import_without_person_absent)
  map.put("roster_import_without_person_double_booked", Res.string.roster_import_without_person_double_booked)
  map.put("roster_import_without_person_inactive", Res.string.roster_import_without_person_inactive)
  map.put("roster_import_without_person_unavailable", Res.string.roster_import_without_person_unavailable)
  map.put("roster_labour_code", Res.string.roster_labour_code)
  map.put("roster_labour_code_hint", Res.string.roster_labour_code_hint)
  map.put("roster_labour_code_none", Res.string.roster_labour_code_none)
  map.put("roster_labour_code_title", Res.string.roster_labour_code_title)
  map.put("roster_more_actions", Res.string.roster_more_actions)
  map.put("roster_move_started", Res.string.roster_move_started)
  map.put("roster_next_month", Res.string.roster_next_month)
  map.put("roster_no_day_templates", Res.string.roster_no_day_templates)
  map.put("roster_no_employee", Res.string.roster_no_employee)
  map.put("roster_no_open_skeleton_shifts", Res.string.roster_no_open_skeleton_shifts)
  map.put("roster_no_templates", Res.string.roster_no_templates)
  map.put("roster_open_shift_claimed", Res.string.roster_open_shift_claimed)
  map.put("roster_open_shift_hint", Res.string.roster_open_shift_hint)
  map.put("roster_open_shift_label", Res.string.roster_open_shift_label)
  map.put("roster_open_shift_toggle", Res.string.roster_open_shift_toggle)
  map.put("roster_open_short", Res.string.roster_open_short)
  map.put("roster_overview_availability", Res.string.roster_overview_availability)
  map.put("roster_overview_by_email", Res.string.roster_overview_by_email)
  map.put("roster_overview_no_warnings", Res.string.roster_overview_no_warnings)
  map.put("roster_overview_team", Res.string.roster_overview_team)
  map.put("roster_overview_title", Res.string.roster_overview_title)
  map.put("roster_overview_warnings", Res.string.roster_overview_warnings)
  map.put("roster_picker_absent", Res.string.roster_picker_absent)
  map.put("roster_picker_away", Res.string.roster_picker_away)
  map.put("roster_picker_guest_from", Res.string.roster_picker_guest_from)
  map.put("roster_picker_guests_hint", Res.string.roster_picker_guests_hint)
  map.put("roster_picker_month_hours", Res.string.roster_picker_month_hours)
  map.put("roster_picker_month_hours_target", Res.string.roster_picker_month_hours_target)
  map.put("roster_picker_nobody", Res.string.roster_picker_nobody)
  map.put("roster_picker_over_target", Res.string.roster_picker_over_target)
  map.put("roster_picker_same_day", Res.string.roster_picker_same_day)
  map.put("roster_picker_title", Res.string.roster_picker_title)
  map.put("roster_planned_hours", Res.string.roster_planned_hours)
  map.put("roster_planned_hours_of", Res.string.roster_planned_hours_of)
  map.put("roster_planned_time", Res.string.roster_planned_time)
  map.put("roster_previous_month", Res.string.roster_previous_month)
  map.put("roster_publish", Res.string.roster_publish)
  map.put("roster_publish_changes", Res.string.roster_publish_changes)
  map.put("roster_publish_keep_open", Res.string.roster_publish_keep_open)
  map.put("roster_publish_leftovers", Res.string.roster_publish_leftovers)
  map.put("roster_publish_open_note", Res.string.roster_publish_open_note)
  map.put("roster_publish_remove", Res.string.roster_publish_remove)
  map.put("roster_published", Res.string.roster_published)
  map.put("roster_published_state", Res.string.roster_published_state)
  map.put("roster_publishing", Res.string.roster_publishing)
  map.put("roster_publishing_hint", Res.string.roster_publishing_hint)
}
